import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-footer" }
const _hoisted_2 = { class: "footer-left" }
const _hoisted_3 = { class: "total-count" }
const _hoisted_4 = { class: "footer-center" }
const _hoisted_5 = { class: "footer-right" }

interface Props {
  totalCount: number;
  currentPage: number;
  itemsPerPage: number;
  totalPages: number;
  pageSizeOptions?: number[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TablePagination',
  props: {
    totalCount: {},
    currentPage: {},
    itemsPerPage: {},
    totalPages: {},
    pageSizeOptions: { default: () => [10, 20, 50] }
  },
  emits: ["update:currentPage", "update:itemsPerPage"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _cache[2] || (_cache[2] = _createTextVNode("총 ", -1)),
        _createElementVNode("strong", null, _toDisplayString(__props.totalCount.toLocaleString()), 1),
        _cache[3] || (_cache[3] = _createTextVNode("건", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.totalPages > 1)
        ? (_openBlock(), _createBlock(_component_v_pagination, {
            key: 0,
            "model-value": __props.currentPage,
            length: __props.totalPages,
            "total-visible": 7,
            density: "compact",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:currentPage', $event)))
          }, null, 8, ["model-value", "length"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_select, {
        "model-value": __props.itemsPerPage,
        items: __props.pageSizeOptions,
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        class: "page-size-select",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:itemsPerPage', $event)))
      }, {
        selection: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.value) + "건씩", 1)
        ]),
        _: 1
      }, 8, ["model-value", "items"])
    ])
  ]))
}
}

})